'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var variants = require('../variants-f3dad7e6.js');
var index = require('../index-70540d0b.js');
var definitions = require('../definitions-4ae1604d.js');
require('../lib-75591456.js');
require('tslib');
require('react');
require('classnames');
require('styled-components');
require('@prisjakt/design-tokens/light-theme-colors');
require('@prisjakt/design-tokens/dark-theme-colors');
require('@prisjakt/design-tokens/measurements');
require('../index-6f152094.js');
require('../variants-434e0406.js');



exports.IconButton = variants.IconButton;
exports.MediaButton = variants.MediaButton;
exports.OutlinedButton = variants.OutlinedButton;
exports.PrimaryButton = variants.PrimaryButton;
exports.TagButton = variants.TagButton;
exports.TextButton = variants.TextButton;
exports.ToggleButton = variants.ToggleButton;
exports.TonalButton = variants.TonalButton;
exports.ButtonIcon = index.ButtonIcon;
Object.defineProperty(exports, 'ButtonOpacity', {
	enumerable: true,
	get: function () { return index.Opacity; }
});
Object.defineProperty(exports, 'ButtonRadius', {
	enumerable: true,
	get: function () { return index.Radius; }
});
Object.defineProperty(exports, 'ButtonSize', {
	enumerable: true,
	get: function () { return index.Size; }
});
exports.ButtonText = index.ButtonText;
Object.defineProperty(exports, 'ButtonTone', {
	enumerable: true,
	get: function () { return index.Tone; }
});
Object.defineProperty(exports, 'ButtonType', {
	enumerable: true,
	get: function () { return index.Type; }
});
Object.defineProperty(exports, 'ButtonElevation', {
	enumerable: true,
	get: function () { return definitions.Elevation; }
});
//# sourceMappingURL=variants.js.map
